import { Trial } from '../../../model/trial';
import { TrialUtils } from '../../utils/trial/trial-utils';
import { OmapiIdsUtils } from '../../utils/omapi-ids/omapi-ids-utils';
var TrialSalesOffersMapper = /** @class */ (function () {
    function TrialSalesOffersMapper() {
    }
    TrialSalesOffersMapper.mapToTrials = function (trialSalesOffers, code) {
        var trials = [];
        if (trialSalesOffers) {
            trialSalesOffers.forEach(function (offer) { return trials.push(TrialSalesOffersMapper.mapToTrial(offer, code)); });
        }
        return trials;
    };
    TrialSalesOffersMapper.mapToTrial = function (trialSalesOffer, code) {
        var trial;
        if (trialSalesOffer) {
            trial = new Trial();
            if (OmapiIdsUtils.isDwnUser()) {
                trial.omapiId = trialSalesOffer.labelkey;
            }
            else {
                trial.omapiId = TrialUtils.getTrialOmapiIdForTrialLabel(trialSalesOffer.labelkey);
            }
            trial.duration = trialSalesOffer.duration ? trialSalesOffer.duration.duration : undefined;
            trial.salesOfferingSpecificationId = trialSalesOffer.salesofferingspecificationid;
            trial.label = 'eos-tvshop-' + trialSalesOffer.labelkey;
            trial.voucherid = code;
        }
        return trial;
    };
    return TrialSalesOffersMapper;
}());
export { TrialSalesOffersMapper };
